/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-08-26T10:00:12+02:00
*/

// based on: https://github.com/callemall/material-ui/blob/master/src/utils/dom.js

export default {

  isDescendant(parent, child) {
    let node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },

  offset(el) {
    const rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft,
    };
  },

};
